import { render, staticRenderFns } from "./UploadCredentials.vue?vue&type=template&id=22ee7f1c&scoped=true"
import script from "./UploadCredentials.vue?vue&type=script&lang=js"
export * from "./UploadCredentials.vue?vue&type=script&lang=js"
import style0 from "./UploadCredentials.vue?vue&type=style&index=0&id=22ee7f1c&prod&lang=css"
import style1 from "./UploadCredentials.vue?vue&type=style&index=1&id=22ee7f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee7f1c",
  null
  
)

export default component.exports